"use client";

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

const komputerDepok: ReactNode = (
  <>
    <section className="mb-8">
      <h2 className="text-xl font-bold mb-3">Kenapa Sewa Komputer di Depok Adalah Keputusan Pintar?</h2>
      <p className="mb-4 text-base">
        Di tengah geliat teknologi dan pendidikan, <strong>sewa komputer Depok</strong> bukan cuma solusi hemat, tapi strategi logistik yang efisien. Baik kamu mahasiswa UI, pelaksana pelatihan di Kukusan, atau penyelenggara event di Sawangan, menyewa komputer jauh lebih fleksibel dibandingkan membeli. Fleksibel harga, fleksibel spek, fleksibel waktu.
      </p>
    </section>

    <section className="grid gap-6 mb-10">
      <div className="bg-white shadow-md rounded-2xl p-6 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Area Layanan Sewa Komputer Depok</h3>
        <p className="text-sm leading-relaxed">
          Dari <strong>Margonda</strong> hingga <strong>Cinere</strong>, dari <strong>Beji</strong> sampai <strong>Cimanggis</strong>, tim kami menjangkau seluruh Depok tanpa biaya tersembunyi. Pengantaran cepat, jemput tepat waktu.
        </p>
      </div>

      <div className="bg-white shadow-md rounded-2xl p-6 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Pilihan Komputer Lengkap, Dari Kantoran Hingga High-End</h3>
        <p className="text-sm leading-relaxed">
          Kamu bisa <strong>sewa komputer Depok</strong> sesuai kebutuhan: Core i5 untuk kerja ringan, hingga RTX-series untuk rendering atau AI. Siap pakai, tinggal colok, langsung tancap kerja.
        </p>
      </div>

      <div className="bg-white shadow-md rounded-2xl p-6 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Harga Sewa Komputer Depok Bisa Disesuaikan</h3>
        <p className="text-sm leading-relaxed">
          Mulai dari Rp30rb/hari, kami paham tiap proyek beda kebutuhan. Harga <strong>sewa komputer</strong> menyesuaikan spek, durasi, dan jumlah. Diskon makin besar kalau makin lama.
        </p>
      </div>

      <div className="bg-white shadow-md rounded-2xl p-6 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Support 24 Jam, Teknisi Standby di Depok</h3>
        <p className="text-sm leading-relaxed">
          Komputer hang di tengah pelatihan? Tenang. Teknisi kami bisa ke lokasi kamu langsung.
          <strong>Sewa komputer Depok</strong> dari kami selalu dibackup dengan support lokal.
        </p>
      </div>
    </section>

    <section className="mb-10">
      <h2 className="text-xl font-bold mb-3">Durasi Fleksibel & Penggantian Unit Cepat</h2>
      <p className="mb-4 text-base">
        Mau sewa komputer untuk 3 hari pelatihan, 1 minggu workshop, atau 6 bulan keperluan proyek? Semua bisa. Dan kalau ada kendala teknis, kami ganti unit saat itu juga. Tanpa ribet.
      </p>
    </section>

    <section className="mb-10">
      <h2 className="text-xl font-bold mb-3">Layanan Antar Jemput Komputer ke Seluruh Depok</h2>
      <p className="mb-4 text-base">
        <strong>Sewa komputer Depok</strong> kamu nggak perlu angkat² sendiri. Tim logistik kami akan antar sampai pintu, jemput di akhir durasi. Bisa request setup langsung di tempat.
      </p>
    </section>

    <section className="mb-10">
      <h2 className="text-xl font-bold mb-3">Spesifikasi Komputer Sewa Sesuai Kebutuhan</h2>
      <p className="mb-4 text-base">
        Mau komputer dengan RAM 16GB, SSD 1TB, atau GPU Nvidia? Atau hanya butuh office-spec untuk Excel? Semua tersedia. <strong>Sewa komputer Depok</strong> kami bisa disesuaikan hingga detail terkecil.
      </p>
    </section>

    <CTA
      title="Siap Kerja di Depok Sampai ke Pinggiran?"
      description="🚚 Butuh sewa komputer Depok sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Komputer Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20komputer%20untuk%20Depok.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ category="Komputer" />
  </>
);

export default komputerDepok;